import React from 'react'

const MarkBarnes = () =>
  <div className="page bio">
    Mark Barnes
  </div>

export default MarkBarnes
